export const pageMaxWidth = 'max-w-[1140px]'
export const pageXPadding = 'px-[40px] md:px-[95px] lg:px-[150px] '
export const pageYPadding = 'py-[40px] md:py-[50px] lg:py-[80px]'
export const socialHandles = [
  {
    title: 'facebook',
    url: 'https://www.facebook.com/bhairabsupplier',
  },
  {
    title: 'tiktok',
    url: '',
  },

  {
    title: 'youtube',
    url: '',
  },
  {
    title: 'instagram',
    url: '',
  },
]

export const config = {
  apiUrl: process.env.REACT_APP_API_URL as string,
}
